module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_mens_make-295da4c1d6067efacff57fd65b880c05.jpg";